import { initializeApp } from "firebase/app";
import { getAnalytics, logEvent } from "firebase/analytics";

const firebaseConfig = {
    apiKey: "AIzaSyBOhGuIBLRGK_02nb9NNalOwdqPMDI5jlM",
    authDomain: "iraq-real-estate-6e4b5.firebaseapp.com",
    projectId: "iraq-real-estate-6e4b5",
    storageBucket: "iraq-real-estate-6e4b5.firebasestorage.app",
    messagingSenderId: "659534766239",
    appId: "1:659534766239:web:8594bc299ada41d75dc2aa",
    measurementId: "G-PFLZTJYQZ1"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

const logFirebaseEvent = (eventName, eventParams) => {
    if (analytics) {
        logEvent(analytics, eventName, eventParams);
    } else {
        console.warn("Firebase Analytics is not initialized.");
    }
};

export { app, analytics, logFirebaseEvent }